// see DOI: 10.1186/1471-2318-10-57
// article may have sign error in predicted DFS male formula 
function dfsScore(data) {
    let dfs=null,isFragile=null,
      Fatigue = data.Fatigue,
      LossOfAppetite = isLossOfAppetite(data.LossOfAppetite),
      GripStrength = weakness(data.left, data.right),
      FunctionalDifficulties = slowness(data.walk, data.stairs),
      PhysicalActivity = data.lowActivity;
      if(data.sex == "f"){
        dfs=      
          femaleDFS(
            Fatigue,
            LossOfAppetite,
            GripStrength,
            FunctionalDifficulties,
            PhysicalActivity
          );
          isFragile=fragileFemaleDFS(dfs)
      }else{
        dfs= maleDFS(
          Fatigue,
          LossOfAppetite,
          GripStrength,
          FunctionalDifficulties,
          PhysicalActivity
        );
        isFragile=fragileMaleDFS(dfs)
      }
      return {dfs,isFragile};
}
function isLossOfAppetite(LossOfAppetite) {
    return LossOfAppetite == "less" ? 1 : 0;
  }
  // kg
  function weakness(left, right) {
    return Math.max(left.first, left.second, right.first, right.second);
  }
  function slowness(walk, stairs) {
    // 2 no are 0 , 1 yes is 1
    return walk + stairs > 0 ? 1 : 0;
}
function femaleDFS(
    Fatigue,
    LossOfAppetite,
    GripStrength,
    FunctionalDifficulties,
    PhysicalActivity
  ) {
    return (
      (2.077707 * Fatigue - 0.757295) * 0.4088 + // DF 0.85 {No => 0, Yes=>1} rDF=DF ~1         [-0.31, 0.54]
      (3.341539 * LossOfAppetite - 0.332289) * 0.3325 + // DA 1.11 {No => 0, Yes=>1} rDA=DA ~1  [-0.11, 1.00]
      (0.132827 * GripStrength - 3.534515) * -0.491 + // DG -0.065 {MAX Kg} rDG~ -1e-3 ~0.05    (5: 1.41, 10: 1.08, 15: 0.76, 20: 0.43, 30: -0.22, 40: -0.87)
      (2.627085 * FunctionalDifficulties - 0.461808) * 0.6012 + // DD 1.58 {0,1} rDD=DD ~1      [-0.28, 1.30]
      (0.918866 * PhysicalActivity - 1.523633) * 0.4818 // DP 0.44 {0-4} rDP ~ DP/2 ~1          [-0.73, -0.29, 0.15, 0.59,  1.04]
    );
  }
  function maleDFS(
    Fatigue,
    LossOfAppetite,
    GripStrength,
    FunctionalDifficulties,
    PhysicalActivity
  ) {
    return (
      (2.280336 * Fatigue - 0.592393) * 0.3762 + //  [-0.22, 0.64]
      (4.058274 * LossOfAppetite - 0.263501) * 0.3130 + //  [-0.08, 1.19]
      (0.092326 * GripStrength - 3.986646) * -0.4653 + // BUGBUG 0.4653 IS NEG IN htm file BUT not in article (5: -1.64, 10: -1.43, 20: -1.00, 30: -0.56, 40: -0.14, 50: 0.29, 60: 0.72)
      (3.098226 * FunctionalDifficulties - 0.365971) * 0.6146 + // [-0.22, 1.68]
      (1.005942 * PhysicalActivity - 1.571803) * 0.4680 //  [-0.74, -0.26, 0.21, 0.68, 1.15]
    );
  }

  function fragileFemaleDFS(d) {
    return d < 0.3151361243
      ? -1 // "Non-fragile"
      : d < 2.1301121973
      ? 0 // "Pre-fragile"
      : d < 6
      ? 1 // "Fragile"
      : "";
  }

  function fragileMaleDFS(d) {
    return d < 1.211878526
      ? -1 // "Non-fragile"
      : d < 3.0052612772
      ? 0 // "Pre-fragile"
      : d < 7
      ? 1 // "Fragile"
      : "";
  }

  export {dfsScore}